import { useState } from "react";
export default function useForm(initial = {}) {
  console.log({initial})
  const [form, setForm] = useState(initial);

  const onChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => {
      const newPrev = { ...prev };

      let currentObj = newPrev;
      if(typeof name == 'string') {

        const arr = name.split("[")
        arr.forEach((key, index) => {
          key = key.replace("]", "");
          if (!currentObj[key]) {
            currentObj[key] = {};
          }
          
          if (index === arr.length - 1) {
            currentObj[key] = value;
          }
          
          currentObj = currentObj[key];
        });
      } else if (typeof name == 'number') {
        newPrev[name] = value
      }
      return newPrev;
    });
  };
  return { form, setForm, onChange };
}
